import { memo, FunctionComponent } from 'react';
// import Dropzone from 'react-dropzone'
import { useDropzone } from 'react-dropzone';
import { Box } from 'elements/Dropzone/style';
import { isEmpty } from 'lodash';

const DropZoneFile: FunctionComponent<any> = ({
  children,
  acceptedFile = {},
  maxFileSize = 314572800,
  onDrop,
  hasData,
  maxFiles = 5,
}) => {
  const { acceptedFiles, fileRejections, getRootProps, getInputProps } =
    useDropzone({
      accept: acceptedFile,
      maxSize: maxFileSize,
      onDrop,
      maxFiles,
    });

  return (
    <Box>
      <div
        {...getRootProps({
          className: `${
            !isEmpty(acceptedFiles) || hasData ? 'files dropzone' : 'dropzone'
          }`,
        })}
      >
        <input {...getInputProps()} />
        {children}
      </div>
    </Box>
  );
};


export default memo(DropZoneFile);
